import Controller from '@ember/controller';
import { action, get } from '@ember/object';
import { service } from '@ember/service';
import ENV from 'donor-elf-web/config/environment';

export default Controller.extend({
  fundsService: service(),

  onFundUploadComplete: action(function () {
    let fundId = get(this, 'fundsService.selectedFund.id');
    window.location.href = `${ENV.rootURL}funds/${fundId}`;
  }),
});
